export default __webpack_public_path__ + "static/media/SWT0090.34I-21364_-14904_0.12f4b5c4.jpg";